export default {"src":"/_next/static/media/keynote-doc.202c23fb.svg","height":40,"width":40};